<script>
	import Tooltip from "./Tooltip.svelte";
	export let name;
	export let cols = null;
	export let scale = "md";
	export let label = null;
	export let sublabel = null;
	export let value;
	export let optionList;
	export let labelProperty = "label";
	export let valueProperty = "value";
	export let validator = null;
	export let validatorValue = null;
	export let validatorMessage = null;
	export let validatorTarget = ".radio-error";
	export let isVeritcal = false;

	export let required;
	export let disabled = null;
	export let labelWithTooltip;
	export let tooltipText = "";
	export let labelBeforeTooltip = "";
	export let labelAfterTooltip = "";

	let numcols = cols ? `-${cols}` : "";
	scale = scale ? `-${scale}` : "";
	scale = numcols == "" ? "" : scale;
</script>

{#if label || labelWithTooltip}
	<!-- svelte-ignore a11y-label-has-associated-control -->
	<label>
		{#if labelWithTooltip}
			<span>
				{labelBeforeTooltip}
				<Tooltip text={tooltipText}>
					<span>{labelWithTooltip}</span>
				</Tooltip>
				{labelAfterTooltip}
			</span>
		{:else}
			{label}
		{/if}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}

{#if optionList && optionList.length}
	<div class={isVeritcal ? "column" : "row"} class:multi-row={cols || optionList.length > 12 / cols}>
		{#each optionList as option, i}
			<div class="col{scale}{numcols}" class:multi-row={cols || optionList.length > 12 / cols}>
				<input
					type="radio"
					id="{name}_{i}"
					bind:group={value}
					class="custom-control-input"
					value={option[valueProperty]}
					{name}
					on:change
					data-validator={validator}
					data-validator-value={validatorValue}
					data-bouncer-message={validatorMessage}
					data-bouncer-target={validatorTarget}
					{required}
					{disabled} />
				<label for="{name}_{i}">
					{option[labelProperty]}
				</label>
			</div>
		{/each}
		<div class="radio-error invalid"></div>
	</div>
{:else}
	No options
{/if}

<style>
	.row {
		margin-top: 0;
	}

	.multi-row {
		margin-bottom: 12px;
	}

	.row.multi-row {
		margin-bottom: -12px;
	}

	/* Base for label styling */
	[type="radio"]:not(:checked),
	[type="radio"]:checked {
		position: absolute;
		left: -9999px;
	}

	[type="radio"]:not(:checked) + label,
	[type="radio"]:checked + label {
		position: relative;
		text-align: center;
		width: 100%;
		min-height: 50px;
		border: 2px solid #ccc;
		background: #fff;
		border: solid 1px var(--color-border);
		border-radius: 1px;
		padding: var(--spacing-sm);
	}

	[type="radio"]:focus + label {
		text-decoration: underline;
	}

	.invalid [type="radio"]:not(:checked) + label,
	.invalid [type="radio"]:checked + label {
		border: solid 2px var(--color-error);
	}

	[type="radio"]:checked + label {
		border-color: var(--color-primary);
		color: var(--color-primary) !important;
		box-shadow: inset 0 0 0 1px var(--color-primary) !important;
	}

	[type="radio"]:checked + label:after,
	[type="radio"]:not(:checked) + label:after {
		content: "";
		position: absolute;
		height: 18px;
		width: 18px;
		border-radius: 50%;
		background-color: var(--color-primary);
		z-index: 2;
		transition:
			top 0.4s,
			right 0.4s,
			opacity 0.4s;
	}

	[type="radio"]:checked + label:before,
	[type="radio"]:not(:checked) + label:before {
		content: "";
		position: absolute;
		transition: all 0.2s;
		border-bottom: 2px solid var(--color-white);
		border-right: 2px solid var(--color-white);
		transform: rotate(35deg);
		width: 6px;
		height: 10px;
		z-index: 3;
		transition:
			top 0.4s,
			right 0.4s,
			opacity 0.4s;
	}

	[type="radio"]:checked + label:after {
		top: -9px;
		right: -9px;
		opacity: 1;
	}

	[type="radio"]:checked + label:before {
		top: -6px;
		right: -3px;
		opacity: 1;
	}

	[type="radio"]:not(:checked) + label:after {
		top: 12px;
		right: 12px;
		opacity: 0;
	}

	[type="radio"]:not(:checked) + label:before {
		top: 15px;
		right: 18px;
		opacity: 0;
	}

	[type="radio"]:disabled + label {
		border: solid 1px var(--color-soft);
		background-color: var(--color-white);
		opacity: 1;
		color: #333 !important;
		box-shadow: none !important;
		min-height: 40px;
		line-height: 18px;
	}

	[type="radio"]:disabled:checked + label {
		background-color: var(--color-soft);
	}

	[type="radio"]:disabled:checked + label:after {
		background-color: var(--color-border);
	}
</style>
